import useSwr from "@/core/composables/swr/useSwr";
import {notificationSequenceApi} from "@/container";
import {
    NotificationSequenceInstanceIndexRequest
} from "@/core/http/resources/notification-sequence/NotificationSequenceResource";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";

const useNotificationSequenceInstance = (instanceId: number | string, params: NotificationSequenceInstanceIndexRequest = {}) => {
    const key = computed(() => {
        return cacheKey(`notification-sequences/${instanceId}/instances`, params);
    });

    return useSwr(
        key,
        () => notificationSequenceApi().instancesIndex(instanceId, params),
    );
};

export default useNotificationSequenceInstance;
